import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircleIcon, HomeIcon, TrophyIcon } from '@heroicons/react/24/outline';
import NavBar from '../../components/navBar';

const RegistrationSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const registrationData = location.state?.registrationData;

  return (
    <div className="min-h-screen bg-gray-900">
      <NavBar />
      <div className="container mx-auto px-4 py-8 mt-16">
        <div className="max-w-2xl mx-auto">
          <div className="bg-gray-800 rounded-xl p-8 shadow-2xl text-center">
            {/* Success Icon */}
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-green-600 rounded-full flex items-center justify-center">
                <CheckCircleIcon className="h-12 w-12 text-white" />
              </div>
            </div>

            {/* Success Message */}
            <h1 className="text-3xl font-bold text-white mb-4">
              Registration Successful!
            </h1>
            <p className="text-gray-400 text-lg mb-8">
              Your club has been successfully registered for the Rising Stars league.
            </p>

            {/* Registration Details */}
            {registrationData && (
              <div className="bg-gray-700 rounded-lg p-6 mb-8 text-left">
                <h2 className="text-xl font-bold text-white mb-4">Registration Details</h2>
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-gray-400">Club:</span>
                    <span className="text-white font-semibold">{registrationData.selectedClub?.name}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-400">League:</span>
                    <span className="text-white font-semibold">{registrationData.selectedProvince?.name}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-400">Season:</span>
                    <span className="text-white font-semibold">{registrationData.seasonYear}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-400">Status:</span>
                    <span className="text-green-400 font-semibold">Active</span>
                  </div>
                </div>
              </div>
            )}

            {/* Next Steps */}
            <div className="bg-blue-900/20 border border-blue-500/30 rounded-lg p-6 mb-8">
              <h3 className="text-lg font-semibold text-blue-400 mb-3">What's Next?</h3>
              <ul className="text-gray-300 space-y-2 text-left">
                <li className="flex items-start">
                  <span className="text-blue-400 mr-2">•</span>
                  You will receive a confirmation email with your registration details
                </li>
                <li className="flex items-start">
                  <span className="text-blue-400 mr-2">•</span>
                  League fixtures and schedules will be announced soon
                </li>
                <li className="flex items-start">
                  <span className="text-blue-400 mr-2">•</span>
                  Keep an eye on your email for important updates
                </li>
                <li className="flex items-start">
                  <span className="text-blue-400 mr-2">•</span>
                  Contact league officials if you have any questions
                </li>
              </ul>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => navigate('/sports')}
                className="flex items-center justify-center px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors"
              >
                <HomeIcon className="h-5 w-5 mr-2" />
                Back to Sports
              </button>
              <button
                onClick={() => navigate('/')}
                className="flex items-center justify-center px-6 py-3 bg-gray-600 hover:bg-gray-500 text-white rounded-lg transition-colors"
              >
                <TrophyIcon className="h-5 w-5 mr-2" />
                View Other Competitions
              </button>
            </div>

            {/* Contact Information */}
            <div className="mt-8 pt-6 border-t border-gray-700">
              <p className="text-gray-400 text-sm">
                Need help? Contact us at{' '}
                <a href="mailto:support@desactv.com" className="text-red-400 hover:text-red-300">
                  support@desactv.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess; 